import React from 'react';
import { Box, Typography } from '@mui/material';

const PREVIEW_MAX_WIDTH = 72;

function PolaroidSizeThumb({ size, selected, onClick, disabled }) {
  const w = Number(size.width_mm) || 1;
  const h = Number(size.height_mm) || 1;
  const iw = Number(size.image_width_mm) || 0;
  const ih = Number(size.image_height_mm) || 0;
  const it = Number(size.image_top_mm) || 0;
  const il = Number(size.image_left_mm) || 0;
  const scale = PREVIEW_MAX_WIDTH / w;
  const previewH = h * scale;

  return (
    <Box
      component="button"
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={selected}
      className={`polc-size-option${selected ? ' polc-size-option--active' : ''}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.75,
        p: 1,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : 'transparent',
        borderRadius: 1.5,
        bgcolor: selected ? 'action.selected' : 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'border-color 0.15s, background-color 0.15s',
        '&:hover': disabled
          ? {}
          : {
              borderColor: selected ? 'primary.main' : 'divider',
              bgcolor: 'action.hover',
            },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2,
        },
      }}
    >
      <Box
        sx={{
          width: PREVIEW_MAX_WIDTH,
          height: previewH,
          bgcolor: '#fff',
          boxShadow: 1,
          position: 'relative',
          flexShrink: 0,
        }}
      >
        {iw > 0 && ih > 0 && (
          <Box
            sx={{
              position: 'absolute',
              left: il * scale,
              top: it * scale,
              width: iw * scale,
              height: ih * scale,
              bgcolor: 'grey.400',
            }}
          />
        )}
      </Box>
      <Typography variant="caption" fontWeight={selected ? 600 : 400} textAlign="center" lineHeight={1.2}>
        {size.label}
      </Typography>
      <Typography variant="caption" color="text.secondary" fontSize="0.65rem" lineHeight={1.1}>
        {size.width_mm}×{size.height_mm} mm
      </Typography>
    </Box>
  );
}

export default function PolaroidSizePicker({ sizes, value, onChange, disabled = false }) {
  if (!sizes?.length) {
    return null;
  }

  return (
    <Box className="polc-size-picker" sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {sizes.map((size) => (
        <PolaroidSizeThumb
          key={size.code}
          size={size}
          selected={value === size.code}
          disabled={disabled}
          onClick={() => onChange(size.code)}
        />
      ))}
    </Box>
  );
}
